import axios from "axios";

let apiUrl = process.env.VUE_APP_ROOTAPI;

const Api = axios.create({
  baseURL: apiUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default Api;
